<template>
    <div>
        客户经理交易明细
    </div>
</template>

<script>
    export default {
        name: "RptSalTraDet"
    }
</script>

<style scoped>

</style>
